/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Api.
 * @export
 */
export const ICON_API = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2968_67)">
      <path
        d="M13 13C12.44 13.56 11.55 13.56 11 13.01V13C10.45 12.45 10.45 11.56 11 11.01V11C11.55 10.45 12.44 10.45 12.99 11H13C13.55 11.55 13.55 12.45 13 13ZM12 6.00002L14.12 8.12002L16.62 5.62002L13.42 2.42002C12.64 1.64002 11.37 1.64002 10.59 2.42002L7.38996 5.62002L9.88996 8.12002L12 6.00002ZM5.99996 12L8.11996 9.88002L5.61996 7.38002L2.41996 10.58C1.63996 11.36 1.63996 12.63 2.41996 13.41L5.61996 16.61L8.11996 14.11L5.99996 12ZM18 12L15.88 14.12L18.38 16.62L21.58 13.42C22.36 12.64 22.36 11.37 21.58 10.59L18.38 7.39002L15.88 9.89002L18 12ZM12 18L9.87996 15.88L7.37996 18.38L10.58 21.58C11.36 22.36 12.63 22.36 13.41 21.58L16.61 18.38L14.11 15.88L12 18Z"
        fill="#707070"
      />
    </g>
    <defs>
      <clipPath id="clip0_2968_67">
        <rect fill="white" height="24" width="24" />
      </clipPath>
    </defs>
  </svg>
);
